import { render, staticRenderFns } from "./order-modal-payments-note.vue?vue&type=template&id=fe4628c8&scoped=true"
import script from "./order-modal-payments-note.vue?vue&type=script&lang=js"
export * from "./order-modal-payments-note.vue?vue&type=script&lang=js"
import style0 from "./order-modal-payments-note.vue?vue&type=style&index=0&id=fe4628c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4628c8",
  null
  
)

export default component.exports